import * as React from "react";
import { MuiThemeProvider, createMuiTheme } from "@material-ui/core/styles";
import CssBaseline from "@material-ui/core/CssBaseline";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import fonts from "./constants/fonts";
import { palette } from "./constants/palette";
import { UIMessageProvider } from "./components/UIMessage";
import { ConfirmProvider } from "./components/ConfirmContext";

const theme: any = createMuiTheme({
  // By assigning 'main', we let MUI calculate
  // other shade values based on this color value
  palette: {
    error: {
      main: palette.ERROR
    },
    primary: {
      // MUI's calculation doesn't work very nicely in this instance
      main: palette.PRIMARY,
      dark: "#402961",
      light: "#A990C8"
    },
    secondary: {
      main: palette.SECONDARY
    }
  },
  typography: {
    fontFamily: [`'${fonts.BODY}'`, "Arial", "sans-serif"].join(","),
    h1: {
      fontFamily: [`'${fonts.HEADER}'`, "Arial", "sans-serif"].join(",")
    }
  },
  overrides: {
    MuiFormLabel: {
      root: {
        "&$focused": {
          color: palette.SECONDARY
        }
      }
    },
    MuiInput: {
      underline: {
        "&:after": {
          borderBottom: `2px solid ${palette.SECONDARY}`
        }
      }
    },
    MuiTab: {
      root: {
        textTransform: "capitalize"
      }
    }
  }
});

function withRoot<P>(Component: React.ComponentType<P>) {
  function WithRoot(props: P) {
    return (
      <MuiThemeProvider theme={theme}>
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
          <CssBaseline />
          <ConfirmProvider>
            <UIMessageProvider>
              <Component {...props} />
            </UIMessageProvider>
          </ConfirmProvider>
        </MuiPickersUtilsProvider>
      </MuiThemeProvider>
    );
  }

  return WithRoot;
}

export default withRoot;
